import styled from "styled-components"
import FitIcon from "./FitIcon"
import RatingIcon from "./RatingIcon"
import { FlexBox } from "components/Common/FlexBox"
import CloseIcon from "./CloseIcon"
import { useTurnOffFitBanner } from "features/notification/useShowFitBanner"
import HaffRatingIcon from "./HalfRatingIcon"

const FitBannerWrapper = styled.div`
  height: 58px;
  width: 100%;
  background-color: #fff;
  position: relative;
  z-index: 100;
`

const FitBannerInner = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 8px 16px;
  padding-left: 4px;
  gap: 8px;
`

const FitName = styled.h5`
  font-size: 14px;
  font-weight: 700;
  line-height: 120%;
`

const RatingText = styled.div`
  display: flex;
  font-size: 10px;
  font-weight: 500;
  color: #576066;
  align-items: center;
  line-height: 12px;
`

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const InstallLink = styled.a`
  height: 35px;
  width: 92px;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  text-decoration: none;
  border-radius: 99px;
  background: var(--Schemes-Primary-Container, #4bd9de);
  margin-left: auto;

  font-size: 16px;
  color: #023648;
  font-weight: 700;
`

const CloseIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  flex-shrink: 0;
`

const FitBanner = () => {
  const onTurnOffShowFitBanner = useTurnOffFitBanner()
  return (
    <FitBannerWrapper>
      <FitBannerInner>
        <CloseIconWrapper onClick={onTurnOffShowFitBanner}>
          <CloseIcon />
        </CloseIconWrapper>

        <FitIcon style={{ width: 42, height: 42 }} />

        <InfoBox>
          <FitName>ZOZOFIT</FitName>
          <FlexBox
            style={{ height: 8 }}
            $justify="flex-start"
            $gap={4}
            $alignItems="center"
          >
            <RatingIcon />
            <RatingIcon />
            <RatingIcon />
            <RatingIcon />
            <HaffRatingIcon />
            <RatingText>4.7</RatingText>
          </FlexBox>

          <RatingText>Easier Access + More Features</RatingText>
        </InfoBox>
        <InstallLink target="_blank" href="https://zozofit.com">
          Install
        </InstallLink>
      </FitBannerInner>
    </FitBannerWrapper>
  )
}

export default FitBanner
